import React from 'react';
import { X, ExternalLink } from 'lucide-react';
import { Card } from '../ui';

export const AML_COLORS = { associate: '#B48AE0', pil: '#3FB8B0', offshore: '#E37A72', subject: '#8A8F97', shareholder: '#D4AF37', director: '#6FA8DC', subsidiary: '#5FC18F', parent: '#C792EA', affiliate: '#8A8F97' };
export const AML_LABELS = { associate: 'Familiari e collegati', pil: 'Cariche PIL', offshore: 'Offshore Leaks' };
export const NODE_KIND = (n) => ({ entity: 'Ente locale (PIL)', offshore: 'Offshore Leaks', company: 'Società' }[n.type] || 'Persona');

const id = (x) => x.id || x;

function Rel({ l, node, nameOf }) {
  const out = id(l.source) === node.id;
  return (
    <div className="text-xs py-1.5 border-b border-[#1F242C] last:border-0">
      <div className="flex gap-2"><span className="w-2 h-2 mt-1 shrink-0" style={{ background: AML_COLORS[l.type] || '#8A8F97' }} />
        <span className="text-[#A3A3A3]">{l.label}</span><span className="text-[#E5E5E5] truncate">{out ? '→' : '←'} {nameOf(out ? id(l.target) : id(l.source))}</span></div>
      {(l.period || l.person) && <p className="text-[#7A7F87] ml-4 mt-0.5">{[l.period, l.person].filter(Boolean).join(' · ')}</p>}
      {l.url && <a href={l.url} target="_blank" rel="noreferrer" className="ml-4 inline-flex items-center gap-1 text-[#D4AF37] hover:underline">Fonte<ExternalLink size={10} /></a>}
    </div>
  );
}

export default function AmlNodePanel({ node, graph, onClose }) {
  const rels = graph.links.filter((l) => id(l.source) === node.id || id(l.target) === node.id);
  const nameOf = (x) => graph.nodes.find((n) => n.id === x)?.label || x;
  return (
    <Card className="p-6 absolute top-4 right-4 w-[min(360px,calc(100%-2rem))] max-h-[calc(100%-2rem)] overflow-y-auto bg-[#0B0D10]/95 backdrop-blur-xl z-10" data-testid="aml-graph-panel">
      <button onClick={onClose} className="absolute top-4 right-4 text-[#5A5F67] hover:text-white" data-testid="aml-graph-panel-close"><X size={16} /></button>
      <p className="text-[11px] uppercase tracking-[0.18em] text-[#D4AF37] mb-3">{NODE_KIND(node)}{node.checked ? ' · verificato' : ''}</p>
      <p className="font-heading text-lg text-[#F2F2F2] mb-2 pr-6" data-testid="aml-graph-panel-name">{node.label}</p>
      {node.outcome && <p className="text-xs font-mono uppercase tracking-wider text-[#D4AF37] mb-2" data-testid="aml-graph-panel-outcome">{node.outcome}</p>}
      {node.check_role && <p className="text-sm text-[#8A8F97] mb-2">{node.check_role}</p>}
      {node.details && <p className="text-sm text-[#8A8F97] mb-2">{node.details}</p>}
      {node.entity_type && <p className="text-xs text-[#7A7F87] mb-1">{node.entity_type}</p>}
      {node.codes?.length > 0 && <p className="text-xs font-mono text-[#5A5F67] mb-1 break-all">{node.codes.join(' · ')}</p>}
      {node.via && <p className="text-xs text-[#7A7F87] mb-1">Dal profilo del soggetto verificato: {node.via}</p>}
      {node.source && <p className="text-xs text-[#7A7F87] mb-1">Fonte: {node.source}</p>}
      {node.url && <a href={node.url} target="_blank" rel="noreferrer" className="text-xs inline-flex items-center gap-1 text-[#D4AF37] hover:underline mb-1" data-testid="aml-graph-panel-link">Apri su Offshore Leaks<ExternalLink size={11} /></a>}
      <p className="text-[11px] uppercase tracking-[0.15em] text-[#5A5F67] mt-5 mb-2">Relazioni ({rels.length})</p>
      {rels.map((l, i) => <Rel key={i} l={l} node={node} nameOf={nameOf} />)}
    </Card>
  );
}
